// Centralized theme tokens for easy swapping or expansion
const themes = {
  greenTheme: {
    "--light-header-color": "#96B0A3",
    "--light-underline-and-button-color": "#254D32",
    "--light-background-and-text-primary": "#EFF2F1",
    "--light-background-secondary": "#ffffff",
    "--light-menu-text-unselected": "rgba(178, 204, 62, .5)",
    "--light-button-selected": "rgb(178, 204, 62)",
    "--light-shadow": "#2c2f3f",
    "--light-timeline-header": "#16A34A8C",
    "--light-highlighted-text": "#65A30D",
    "--light-highlighted-text-hover": "#84CC16",
    "--light-year-text": "#059669",
    "--dark-header-color": "#A6C1B1",
    "--dark-underline-and-button-color": "#A6D4A1",
    "--dark-background-and-text-primary": "#171717",
    "--dark-background-secondary": "#262626",
    "--dark-menu-text-unselected": "rgba(178, 204, 62, 1)",
    "--dark-button-selected": "rgb(178, 204, 62)",
    "--dark-shadow": "#3A4C42",
    "--dark-timeline-header": "#4DAA6A",
    "--dark-highlighted-text": "#A7D04C",
    "--dark-highlighted-text-hover": "#A0D13A",
    "--dark-year-text": "#82A57C",
  },
};

export default themes;
